import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";
import "./styles.scss";
import Back from "../../../../assets/icons/back.svg";
import DocumentSideBarButton from "../../../../containers/Chat/shared/DocumentSideBarButton";
import useWindowDimensions from "../../../../hook/useWindowDimension";

const ChatTitle = ({
																			caremanagerName,
																			caremanagerFirstname,
																			aidant,
																			rdv,
																			freeQuestion,
																			onclick,
																			showSideBar,
																			toggleSideBar,
																			showDocumentButton
																			}) => {
const {width} = useWindowDimensions();
// Quand on provient de chatCase en verison mobile, on passe setChatCaseCMCard(tru) à Card pour afficher la card version mobile chat
const [chatCaseCMCard, setChatCaseCMCard] = useState(false);
useEffect(() => {
setChatCaseCMCard(true);
}, []);
return (
<div className={`${showDocumentButton ? "titre-conversation" : "titre-conversation-bot"}`}>
{width > 5
? <>
<div onClick={onclick} className="goBack"><img src={Back} alt="retour"/></div>
<div>
<h1><strong>{caremanagerFirstname} {caremanagerName}</strong></h1>
<h2> {aidant ? `Pour ${aidant}` : ""} {rdv && <>Pour une prise de
rendez-vous.</>}
{freeQuestion && <>Pour une question gratuite</>}</h2>
</div>
{showDocumentButton &&
<DocumentSideBarButton toggleSideBar={toggleSideBar} showSideBar={showSideBar}/>
}
</>
: <>
<h1> {aidant ? `Pour ${aidant}` : ""} {rdv && <>Pour une prise de
rendez-vous.</>} {freeQuestion && <>Pour une question gratuite</>}</h1>
</>
}
</div>
);
};

ChatTitle.propTypes = {
caremanagerName: PropTypes.string,
caremanagerFirstname: PropTypes.string,
aidant: PropTypes.string,
rdv: PropTypes.bool,
freeQuestion: PropTypes.bool,
showSideBar: PropTypes.bool,
showDocumentButton: PropTypes.bool,
onclick: PropTypes.func,
toggleSideBar: PropTypes.func,
};

export default ChatTitle;